import type { TileData } from 'stores/tilesStore/tiles/tileSchemas'
import { CART_UPSELL_IDS, type CartUpsellId } from './cartUpsells.schemas'

type TileWithMetadata = Pick<TileData, 'metadata'>

export function hasCartUpsellTiles(
  tiles: TileWithMetadata[],
  id: CartUpsellId
): boolean {
  return tiles.some((tile) => tile.metadata?.cartUpsellId === id)
}

export function getCartUpsellTilesAnalyticsProps(tiles: TileWithMetadata[]): {
  'Cart Upsell Tiles Count': number
  'Cart Upsell IDs': CartUpsellId[]
} {
  const tileCartUpsellIds = tiles.flatMap((tile) => {
    const cartUpsellId = CART_UPSELL_IDS.find(
      (id) => id === tile.metadata?.cartUpsellId
    )
    return cartUpsellId ? [cartUpsellId] : []
  })
  return {
    'Cart Upsell Tiles Count': tileCartUpsellIds.length,
    'Cart Upsell IDs': [...new Set(tileCartUpsellIds)],
  }
}
